const enum ArticleLayoutsEnum {
  ONE = 'One',
  ONE_TWO = 'OneTwo',
  TWO = 'Two',
  TWO_TWO = 'TwoTwo',
  THREE = 'Three',
  THREE_TWO_THREE = 'ThreeTwoThree',
  THREE_TWO_TWO = 'ThreeTwoTwo',
}

export default ArticleLayoutsEnum;
